import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { useEntities } from '../use-entities/use-entities';

/**
 * Returns a stable callback that translates a domain entity type string
 * (e.g. 'config-activity') into a human-readable display name
 * (e.g. 'Activity') using the entity's `labelKey`.
 *
 * Falls back to the raw entity type string when no matching entity
 * configuration is found.
 */
export const useGetEntityTypeName = () => {
  const { formatMessage } = useIntl();
  const allEntities = useEntities();

  return React.useCallback(
    (entityType: string, count = 1): string => {
      const translationKey = allEntities.get(entityType)?.labelKey;
      return translationKey
        ? String(formatMessage({ id: translationKey }, { count }))
        : entityType;
    },
    [allEntities, formatMessage],
  );
};
